/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
  TablePagination,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { useCallback, useMemo, useState } from "react";
import { useEffect } from "react";
import defaultListStore from "src/framework/store/DefaultListStore";
import adminStore from "src/store/AdminStore";
import { OptionButton } from "../FilterButton";
import { ModalDetalhes } from "../ModalDetalhes";
import { ModalMppt } from "../ModalMppt";
import { FilterDrawer } from "./FilterDrawer";
import "./style.css";
import { Search } from "@mui/icons-material";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { useObservable } from "src/framework/store/storeUtil";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { FilterButtonComponentes } from "./FilterButtonComponentes";
import theme from "src/theme/light";
import { resolveProtocolUrl } from "src/store/global.store";
import { LoginStore } from "src/framework/store/LoginStore";
import { CategoriaComponente } from "../types";
import { getAtributos } from "src/components/projetos/edicao/layouts/EdicaoLayout";
import { ConfiguracaoStore } from "src/framework/store/ConfiguracaoStore";
import api from "src/framework/providers/api";
import { PROJETOS_ITENS_SEM_SUGESTAO_INSTALACAO } from "src/components/projetos/constants";

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE = 0

export const INITIAL_FILTERS_STATE = {
  search_id: "",
  search_nome: ""
}
export interface FilterProps {
  search_id: string;
  search_nome: string;
}
export interface HandleFiltersParams {
  categoria_ids?: number[];
  page?: number;
  pageSize?: number;
  segmentos?: string[];
  search_id?: string;
  search_nome?: string;

}
enum SELECT_CATEGORIA {
  MODULOS = 1,
  INVERSORES = 2,
  ESTRUTURAS = 3,
  ACESSORIOS = 4,
  MAIS_CATEGORIAS = 5
}

const useStyles = makeStyles({
  paginationToolbarRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  paginationRoot: {
    display: 'flex',
    flexWrap: 'wrap',
  }
})

const store = new ConfiguracaoStore(api, PROJETOS_ITENS_SEM_SUGESTAO_INSTALACAO)

const ComponentesDataTable = () => {
  const classes = useStyles();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  //informação dos filtros
  const [page, setPage] = useState(DEFAULT_PAGE)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)

  const [optionsModulos, setOptionsModulos] = React.useState<OptionButton[]>([]);
  const [optionsInversores, setOptionsInversores] = React.useState<OptionButton[]>([]);
  const [optionsEstruturas, setOptionsEstruturas] = React.useState<OptionButton[]>([]);
  const [optionsAcessorios, setOptionsAcessorios] = React.useState<OptionButton[]>([]);
  const [optionsMaisCategorias, setOptionsMaisCategorias] = React.useState<OptionButton[]>([]);
  const [componentId, setComponentId] = React.useState<number>();
  const [componentMpptId, setComponentMpptId] = React.useState<number>();
  const [componentesEstate, setComponentes] = useState<any>();
  const [categoriasEstate, setCategorias] = useState<any>();
  const [filterBarIsOpened, setFilterBarIsOpened] = useState(false);
  const [filters, setFilters] = useState<FilterProps>(INITIAL_FILTERS_STATE);
  const [userAdm, setUserAdm] = useState<boolean>(false);
  const _upload = LocalStorage.get("solar.uploadInfo", true);
  const permissoes:string[] = useObservable(LoginStore.permissoes) || [];
  const [active, setActive] = useState(0);
  const [produtosIgnorados, setProdutosIgnorados] = useState<number[]>([]);

  //armazena a categoria selecionada
  const [categoriaSelecionada, setCategoriaSelecionada] = React.useState<string>("");

  //comandos
  const clickButtonFilter = (categorias: number[], nome: string, categoria: string, tipo_filtro: number) => {
    setCategorias(categorias);
    setPage(0)
    handleGetComponentes(categorias, 1, pageSize, nome + " - " + categoria, filters);
    setCategoriaSelecionada(nome + " - " + categoria);
    setActive(tipo_filtro)
  }

  const [openModalDetalhes, setOpenModal] = useState(false);
  const handleDetail = async (componentId: number): Promise<void> => {
    setComponentId(componentId);
  }
  //abre ou fecha o modal de detalhes
  const handleOpenModal = (openModal:boolean) => {
    setOpenModal(openModal);
    if (!openModal) {
      setComponentId(0);
    }
  }
  
  const [openModalMppt, setOpenModalMppt] = useState(false);
  const handleDetailMppt = async (componentId: number): Promise<void> => {
    setComponentMpptId(componentId);
  }
  //abre ou fecha o modal de mppt
  const handleOpenModalMppt = (openModal:boolean) => {
    setOpenModalMppt(openModal);
    if (!openModal) {
      setComponentMpptId(0);
    }
  }
  
   const handleFilter = useCallback((params: HandleFiltersParams = {})=>{    
    handleGetComponentes(categoriasEstate, 1, pageSize, categoriaSelecionada, filters);
   },[filters]); 

  const handleSearch = useCallback(()=>{
    handleFilter({
      search_id: filters.search_id,
      search_nome: filters.search_nome,
    })
    setFilterBarIsOpened(false);
  },[handleFilter, filters, pageSize])

  //carrega a url da imagem a partir do modelo
  const getUrl = (row:any) => {
    let url = '';
    const upload = row?.uploads?.filter((u: any) => u?.tipo === 'image');
    if(upload){
      url = upload[0]?.url;
    }
    
    return url;
  }

  useEffect(() => {
    defaultListStore
      .getCategoriaComponentes()
      .then((result: CategoriaComponente[]) => {
        setOptionsModulos([{"id":1, "nome": 'Ver Todos'}]);
        let inversores = [{"id":0, "nome": 'Ver Todos'}].concat(filterCategoriasByGroup(result, "inversores"));
        setOptionsInversores(inversores);
        setOptionsAcessorios([{"id":0, "nome": 'Ver Todos'}].concat(filterExcludeCategoriaById(filterCategoriasByGroup(result, "acessorios"), 200)));//colocar em parâmetro este 200 = "Verticais (Produto 198)"
        setOptionsEstruturas([{"id":0, "nome": 'Ver Todos'}].concat(filterCategoriasByGroup(result, "itens_estrutura")));
        setOptionsMaisCategorias([{"id":0, "nome": 'Ver Todos'}].concat(filterMaisCategorias(result, ["controladores","baterias","iluminacao"])))
        clickButtonFilter(inversores.map((opt)=> {return opt.id}), "Inversores", "Todos", SELECT_CATEGORIA.INVERSORES);
      });
  }, []);


  useEffect(() => {
    const carregarParametros = async () => {
      const parametros = await store.list();
      const valor = parametros?.[0]?.valor ?? "";
      setProdutosIgnorados(valor?.split(",")?.map((item: string) => Number(item.trim()))?.filter(Number.isFinite));
    }
    carregarParametros();
  }, []);

  //filtros de categoria para subdividir na apresentação da tela
  const filterCategoriasByGroup = (categorias:CategoriaComponente[], grupo: string) => {
    return categorias.filter((_categoria: CategoriaComponente) => {
      return _categoria.grupo === grupo;
    });
  };
  const filterExcludeCategoriaById = (categorias:CategoriaComponente[], id: number) => {
    return categorias.filter((_categoria: CategoriaComponente) => {
      return _categoria.id !== id;
    });
  };  
  const filterMaisCategorias = (categorias: CategoriaComponente[], aGrupos: string[]) => {
    return categorias.filter((_categoria: CategoriaComponente) => {
      return aGrupos.includes(_categoria.grupo);
    });
    }

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
    handleGetComponentes(categoriasEstate, newPage + 1, pageSize, categoriaSelecionada, filters);
  },[pageSize, categoriasEstate])

  const handleChangePageSize = useCallback((event) => {
    const pSize = parseInt(event.target.value, 10)
    setPageSize(pSize);
    setPage(0);
    handleGetComponentes(categoriasEstate, 1, pSize, categoriaSelecionada, filters);
  },[categoriasEstate])

  const handleGetComponentes = (categorias: number[], page: number, pageSize: number, categoriaSelecionada: string, customFilters: any) => {
    let filter = 'exibir_listagem=true';
    if (categoriaSelecionada.includes('Módulo')) {
      filter = 'exibir_listagem=true';
    }
    const search_id = customFilters.search_id;
    const search_nome = customFilters.search_nome;
    if (search_id){
      filter += `&id=${search_id}`
    }
    if (search_nome){
      filter += `&modelo_like_or_nome_like=${search_nome}`
    }
    adminStore.getComponentes(categorias, page, pageSize, filter, true).then((resp) => {
      setComponentes(resp)
    })
  }
  useEffect(()=>{
    /* comentado na SOL-430
    const checkAdm = async () => {
      const info = LocalStorage.get("solar.userInfo", true);
      const userId = info.userId;
      const request: IDataRequest = {
        url:`/usuarios?includes=grupos_acesso&id=${userId}`
      }
      const response: IDataResponse = await apiNoLoading.get(request);
      if (response.statusCode === STATUS_CODE.OK) {
        const data = response.data;
        if (data) {
          for (let j=0; j < data.length; j++){
            for (let i=0; i < data[j].grupos_acesso.length; i++){
              if (data[j].grupos_acesso[i].grupo_acesso_id === GRUPO_ACESSO_ADM){
                setUserAdm(true);
              }
            }
          }
        }
      }
    }
    checkAdm();
    */
    setUserAdm(PermissionUtil.isAdministrador(permissoes));
  },[permissoes])

  const canAccessDetalhesMppt = useMemo(() => {
    return (
      PermissionUtil.can(PermissionUtil.PERMISSION_COMPONENTES_MPPT, permissoes)
    )
}, [permissoes])

  const temPermissaoCodigoComponente = useMemo(()=>{
    return PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE, permissoes)
  },[permissoes])

  const CategoriasContent = useCallback(()=>{
    return (
      <>
        <Box display={"flex"} padding={isMobile ? "5px 5px 5px" : "10px 10px 10px"}>
          <FilterButtonComponentes tipoCategoria={SELECT_CATEGORIA.MODULOS} active={active === SELECT_CATEGORIA.MODULOS} nome="Módulos" options={optionsModulos} handleClickButton={clickButtonFilter} />
        </Box>
        <Box display={"flex"} padding={isMobile ? "5px 5px 5px" : "10px 10px 10px"}>
          <FilterButtonComponentes tipoCategoria={SELECT_CATEGORIA.INVERSORES} active={active === SELECT_CATEGORIA.INVERSORES} nome="Inversores" options={optionsInversores} handleClickButton={clickButtonFilter} />
        </Box>
        <Box display={"flex"} padding={isMobile ? "5px 5px 5px" : "10px 10px 10px"}>
          <FilterButtonComponentes tipoCategoria={SELECT_CATEGORIA.ESTRUTURAS} active={active === SELECT_CATEGORIA.ESTRUTURAS} nome="Estruturas" options={optionsEstruturas} handleClickButton={clickButtonFilter} />
        </Box>
        <Box display={"flex"} padding={isMobile ? "5px 5px 5px" : "10px 10px 10px"}>
          <FilterButtonComponentes tipoCategoria={SELECT_CATEGORIA.ACESSORIOS} active={active === SELECT_CATEGORIA.ACESSORIOS} nome="Acessórios" options={optionsAcessorios} handleClickButton={clickButtonFilter} />
        </Box>
        <Box display={"flex"} padding={isMobile ? "5px 5px 5px" : "10px 10px 10px"}>
          <FilterButtonComponentes tipoCategoria={SELECT_CATEGORIA.MAIS_CATEGORIAS} active={active === SELECT_CATEGORIA.MAIS_CATEGORIAS} nome="Mais categorias" options={optionsMaisCategorias} handleClickButton={clickButtonFilter} />
        </Box>
        <Tooltip title='Filtros'>
          <IconButton onClick={() => setFilterBarIsOpened(true)} size="large">
            <Search fontSize="medium" />
          </IconButton>
        </Tooltip>
      </>
    );
  },[active, isMobile, optionsModulos,clickButtonFilter, optionsInversores, optionsEstruturas, optionsAcessorios, optionsMaisCategorias])

  useEffect(()=>{
    const loadCache = async ()=>{
      await getAtributos();
    }
    loadCache();
  },[])

  //renderização da tela
  return (
    <>
      <Box width={"100%"} maxWidth={820} margin="0 auto">
        {isMobile ? (
          <Box mb={"20px"} width={'100%'} display="flex" justifyContent={"flex-start"} flexWrap="wrap" marginTop={'20px'}>
            <CategoriasContent />
          </Box>
        ) : (
          <Box mb={"50px"} width={'100%'} display="flex" justifyContent={"center"}>
            <CategoriasContent />
          </Box>
        )}

        <Box className="categoria_selecionada">
          <Box className="categoria_selecionada_titulo" style={{ marginBottom: isMobile ? "10px" : undefined }}>Categoria:</Box><Box className="categoria_selecionada_texto">{categoriaSelecionada}</Box>

        </Box>
        
        {componentesEstate?.rows?.map((componente: any) => {
          let url = getUrl(componente);
          const ignorarMppt = produtosIgnorados?.includes(componente?.id);
          
          return (
            <Card style={{marginBottom: 20}}>
              <CardContent>
                <Grid container spacing={3} direction={isMobile ? "column" : "row"}>
                  <Grid size={{ xs: 12, md: 3, sm: 3 }}>
                    { url ? 
                      <img className='image-componentes' alt='Componente' src={resolveProtocolUrl(`//${_upload?.data?.url}${url}`)} />
                      :
                      <></>
                    }
                  </Grid>
                  <Grid className="grid-detalhes" size={{ xs:12, md:9, sm:9 }}>
                    <Box component={'h3'} className='titulo-listagem'>
                      {temPermissaoCodigoComponente ? componente?.id + " - ":""}{componente?.nome}
                    </Box>
                    <Box component={'span'} style={{textAlign: 'left', display: 'block'}}>
                      {componente?.descricao}
                    </Box>

                  </Grid>
                </Grid>
              </CardContent>
      
                <CardActions style={{ paddingTop: 0, paddingLeft: 16 }}>
                  <Button
                    style={{padding: 0, left: 10, float: 'left'}}
                    color="primary"
                    onClick={() => {
                      handleDetail(componente?.id);
                    }}
                  >+ DETALHES</Button>
                  {(componente?.categoria_componentes_id === 2 && canAccessDetalhesMppt) ? (
                    <Tooltip title={ignorarMppt ? 'Indisponível para o inversor selecionado' : ''}>
                      <Button
                        style={{
                          padding: 0, left: 20, float: 'left',
                          ...(ignorarMppt && { 
                            color: "rgba(0, 0, 0, 0.26)",
                            borderColor: "rgba(0, 0, 0, 0.12)",
                            opacity: 0.9,
                          })
                        }}
                        id="detalhes_mppt"
                        color="secondary"
                        onClick={() => {
                          if (ignorarMppt) return;
                          handleDetailMppt(componente?.id);
                        }}
                      >DETALHES DO MPPT</Button>
                    </Tooltip>
                  ) : (
                    <></>
                  )}
                </CardActions>
            </Card>
          )
        })}
      </Box>
      { componentesEstate &&
        <TablePagination
          component="div"
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
          classes={isMobile ? { toolbar: classes.paginationToolbarRoot, root: classes.paginationRoot } : {}}
          count={componentesEstate?.infoRows?.count || 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={pageSize}
          onRowsPerPageChange={handleChangePageSize}
          labelRowsPerPage={"Registros por página:"}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count} registros`}
        />
      }

      <ModalDetalhes 
        open={openModalDetalhes}
        setOpenModal={handleOpenModal}
        componentId={componentId}
        ></ModalDetalhes>

      <ModalMppt 
        open={openModalMppt}
        setOpenModal={handleOpenModalMppt}
        componentId={componentMpptId}
        ></ModalMppt>

      <FilterDrawer
        close={() => setFilterBarIsOpened(false)}
        isOpened={filterBarIsOpened}
        filters={filters} 
        setFilters={setFilters}
        handleSearch={handleSearch}
        isAdm={userAdm}
      />
      </>
      
  );
};

export { ComponentesDataTable };
